
const  assistedBookingAgent = (id)=>{
    console.log("agent:",id);
    const requestOptions = {
        method: 'GET',
        headers: { 'Content-Type': 'application/json' },
    };
    return fetch(`/shared/api/assistedBookingAgent?text=${id}`,requestOptions).then((response) => response.json())
}
export default assistedBookingAgent